<template>
  <div class="fl-sym-p-2">
    <div class="fl-sym-flex fl-sym-justify-between fl-sym-relative">
      <div class="fl-sym-w-3/6 fl-sym-z-10 fl-grid">
        <div
          @click="change(options[0].value)"
          :class="{
            'fl-sym-text-intermediate': options[1].value === value,
            'fl-sym-text-white, gender-icons-white': options[0].value === value,
          }"
          class="fl-sym-h-20 fl-sym-rounded-full fl-sym-flex fl-sym-items-center fl-sym-justify-center fl-sym-transition fl-sym-duration-300 fl-sym-ease-in fl-sym-text-sm fl-grid"
        >
          <img src="@/assets/male-icon.svg" width="30" class="gender-icons" />
          {{ options[0].name }}
        </div>
      </div>
      <div class="fl-sym-w-3/6 fl-sym-z-10">
        <div
          @click="change(options[1].value)"
          :class="{
            'fl-sym-text-intermediate': options[0].value === value,
            'fl-sym-text-white, gender-icons-white': options[1].value === value,
          }"
          class="fl-sym-h-20 fl-sym-rounded-full fl-sym-flex fl-sym-items-center fl-sym-justify-center fl-sym-transition fl-sym-duration-300 fl-sym-ease-in fl-sym-text-sm fl-grid"
        >
          <img src="@/assets/female-icon.svg" width="22" class="gender-icons" />
          {{ options[1].name }}
        </div>
      </div>
      <div
        class="fl-sym-absolute fl-sym-w-3/6 fl-sym-h-20 fl-sym-rounded-full fl-sym-bg-intermediate fl-sym-transition-all fl-sym-duration-300 fl-sym-z-0"
        :class="{
          'fl-sym-move-left': options[0].value === value,
          'fl-sym-move-right': options[1].value === value,
        }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: "male",
      type: String,
    },
    options: {
      default: () => {
        return []
      },
      type: Array,
    },
  },
  methods: {
    change(val) {
      this.$emit("input", val)
    },
  },
}
</script>
<style>
.fl-sym-move-left {
  margin-left: 0;
}
.fl-sym-move-right {
  margin-left: 50%;
}
.gender-icons {
  margin: auto;
}
.gender-icons-white {
  filter: invert(1) contrast(20.5);
}
.fl-grid {
  display: grid;
}
</style>
